import { useEffect, useState } from "react";
import { ResultsetVisualizationType } from "../ResultsetVisualizations";
import Plot from "react-plotly.js";
import { Config } from "plotly.js";
import { getRandomColorForLegend } from "../../pages/IndividualResultsetVisualization";

const trainingSetColors = [
    '#ff7f0e',  // safety orange
    '#2ca02c',  // cooked asparagus green
    '#d62728',  // brick red
    '#9467bd',  // muted purple
    '#8c564b',  // chestnut brown
    '#e377c2',  // raspberry yogurt pink
    '#7f7f7f',  // middle gray
    '#bcbd22',  // curry yellow-green
    '#17becf'   // blue-teal
]

export default function MiniVisPlot({
    resultsetName,
    visualization,
    modelFamilyOptions
}: {
    resultsetName: string,
    visualization: ResultsetVisualizationType,
    modelFamilyOptions: { name: string, id: number }[],
}) {
    // const getModelFamiliesMutation = useGetModelFamiliesModelFamilyGet({ include_model_family_metadata: false });
    const [ plotData, setPlotData ] = useState<Plotly.Data[]>([]);

    useEffect(() => {
        if (visualization && modelFamilyOptions.length > 0) {
            // const modelFamilies = getModelFamiliesMutation.data as unknown as ModelFamily[];
            
            const { graph_data, test_keys } = visualization;

            let testTrace = {};
            let trainCount = 0;
            let trainTraces: any[] = [];

            Object.keys(graph_data).forEach(graphDataKey => {
                let name = '';

                if (!isNaN(Number(graphDataKey))) {
                    const matchingModelFamily = modelFamilyOptions.find(family => family.id! === Number(graphDataKey));
                    if (matchingModelFamily) {
                        name = matchingModelFamily.name!;
                    }
                } else {
                    name = resultsetName;
                }
    
                const isTestKey = test_keys.includes(graphDataKey);
                const graphDataValue = graph_data[graphDataKey];

                const { x, y } = graphDataValue;
                const smiles = graphDataValue['structure/SMILES'];

                let moleculeInfo: any[] = [];

                smiles.forEach(smile => {
                    const molObj = {
                        molecule_smiles: smile,
                        set_type: isTestKey ? 'test' : 'train',
                        name,
                        color: isTestKey ? '#1f77b4' : trainingSetColors[trainCount] ?? getRandomColorForLegend(),
                    };
                    moleculeInfo.push(molObj);
                });

                if (isTestKey) {
                    testTrace = {
                        x,
                        y,
                        mode: 'markers',
                        type: 'scatter',
                        name: 'Test',
                        marker: { color: '#1f77b4' },
                    }
                } else {
                    let modelTrace = {};

                    modelTrace = {
                        x,
                        y,
                        mode: 'markers',
                        type: 'scatter',
                        name: 'Train',
                        marker: { color: trainingSetColors[trainCount] },
                    }

                    trainTraces.push(modelTrace);

                    trainCount += 1;
                }
            });

            const data = [testTrace].concat(trainTraces);
            setPlotData(data);
        }


    }, [visualization, modelFamilyOptions, resultsetName]);


    const config: Partial<Config> = {
        scrollZoom: true,
        displaylogo: false,
        displayModeBar: true,
        responsive: true,
        modeBarButtonsToRemove: ['toggleSpikelines', 'resetScale2d', 'hoverCompareCartesian', 'hoverClosestCartesian'],
        toImageButtonOptions: {
            format: 'svg',
            scale: 1,
        }
    };

    const layout_reg: () => Partial<Plotly.Layout> = function() {
    
        return {
            responsive: true,
            autosize: true,
            showlegend:false,
            margin: {
            l: 30,
            r: 10,
            b: 30,
            t: 60,
            pad: 0
            },
            modebar: {
            color: '#555555',
            activecolor: '#315FB5',
            },
        }
    };

    return (
        <div className="w-full p-6">
            {plotData.length > 0 && (
                <Plot 
                    layout={layout_reg()} 
                    data={plotData} 
                    config={config} 
                    className='w-full aspect-square'
                />
            )}
        </div>
    )
}